(function () {
  'use strict';
  var LIF = window.LIF || {};
  var FREE = LIF.freeShipping || 0;
  var text = LIF.text || {};
  var cartPending = false;
  var latestCart = {item_count: Number((document.querySelector('#bagCt') || {}).textContent) || 0};
  var syncProductUI = function () {};
  function setCartPending(value) {
    cartPending = value;
    window.LIF.cartPending = value;
    $all('[data-dq], [data-qchange], [data-drawer-remove], [data-cart-page-form] [data-qty-input]').forEach(function(button) { button.disabled = value; });
    $all('button[name="checkout"]').forEach(function(button) { if (button.closest('#cart-form')) return; button.disabled = value || !!(latestCart && !latestCart.item_count); });
  }


  function money(cents) {
    return new Intl.NumberFormat(LIF.locale || 'en-GB', {style:'currency', currency:LIF.currency || 'GBP'}).format(cents / 100);
  }
  function cartRoute(path) { return (LIF.rootUrl || '/').replace(/\/?$/, '/') + path; }
  function responseJSON(r) { return r.json().then(function(data) { if (!r.ok) throw new Error(data.description || data.message || 'Unable to update your bag. Please try again.'); return data; }); }
  function escapeHTML(value) { return String(value || '').replace(/[&<>"']/g, function(c) { return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function reportError(error) { var el = activePanel === drawer ? $('[data-drawer-feedback]') : $('[data-cart-feedback]'); if (!el) { el = document.createElement('p'); el.className='cart-toast'; el.setAttribute('role','alert'); document.body.appendChild(el); } el.dataset.tone='error'; el.textContent=error.message; }
  function $(s, c) { return (c || document).querySelector(s); }
  function $all(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  /* ---------- Drawer / menu ---------- */
  var drawer = $('#drawer'), scrim = $('#scrim'), mm = $('#mm');
  var lastFocus, activePanel;
  function openPanel(panel) { if (!panel) return; closeAll(false); lastFocus=document.activeElement; activePanel=panel; panel.inert=false; panel.setAttribute('aria-hidden','false'); panel.classList.add('on'); if(scrim) scrim.classList.add('on'); document.body.style.overflow='hidden'; if(burger) burger.setAttribute('aria-expanded',panel===mm?'true':'false'); if(bagBtn) bagBtn.setAttribute('aria-expanded',panel===drawer?'true':'false'); var first=panel.querySelector('button,a,input,select'); if(first) first.focus(); }
  function openBag() { openPanel(drawer); }
  function closeAll(restoreFocus) {
    var wasOpen = !!activePanel;
    [drawer, mm].forEach(function(panel) { if (panel) { panel.classList.remove('on'); panel.setAttribute('aria-hidden', 'true'); panel.inert = true; } });
    if (scrim) scrim.classList.remove('on');
    if (burger) burger.setAttribute('aria-expanded', 'false');
    if (bagBtn) bagBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    activePanel = null;
    if (wasOpen && restoreFocus !== false && lastFocus && lastFocus.isConnected) lastFocus.focus();
  }
  var bagBtn = $('#bagBtn');
  if (bagBtn) bagBtn.addEventListener('click', function (event) { if(event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)return; event.preventDefault(); openBag(); refreshCart().catch(function() {}); });
  var burger = $('#burger'); if (burger) burger.addEventListener('click', function () { openPanel(mm); });
  document.addEventListener('keydown',function(e) { if(e.key!=='Tab'||!activePanel)return; var nodes=$all('a[href],button:not([disabled]),input,select,summary',activePanel).filter(function(x){return x.getClientRects().length;}); if(!nodes.length)return; var first=nodes[0],last=nodes[nodes.length-1]; if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();} });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-close]') || e.target === scrim) closeAll();
    $all('.hdr details[open]').forEach(function(menu) { if (!menu.contains(e.target)) menu.open = false; });
  });
  document.addEventListener('keydown', function(event) {
    if (event.key !== 'Escape') return;
    $all('.hdr details[open]').forEach(function(menu) { menu.open = false; var summary = $('summary', menu); if (summary) summary.focus(); });
  });
  $all('.hdr details').forEach(function(menu) { menu.addEventListener('toggle', function() { if (menu.open) $all('.hdr details[open]').forEach(function(other) { if (other !== menu) other.open = false; }); }); });

  /* ---------- Cart (AJAX) ---------- */
  function renderDrawer(cart) {
    latestCart = cart;
    var checkout = $('[data-drawer-checkout]'); if (checkout) checkout.disabled = cartPending || !cart.item_count;
    var bagCt = $('#bagCt'); if (bagCt) bagCt.textContent = cart.item_count;
    var sub = $('#sub'); if (sub) sub.innerHTML = money(cart.total_price);
    var ship = $('#ship');
    if (ship) {
      var left = FREE - cart.total_price;
      var pct = FREE > 0 ? Math.min(100, cart.total_price / FREE * 100) : 100;
      ship.hidden = FREE <= 0;
      ship.innerHTML = (left > 0 ? 'You are <b>' + money(left) + '</b> away from free UK delivery' : '<b>Free UK delivery</b> unlocked') + '<div class="bar"><i style="width:' + pct + '%"></i></div>';
    }
    var items = $('#items');
    if (items) {
      if (!cart.items.length) { items.innerHTML = '<div class="empty"><p>' + escapeHTML(text.emptyBag || 'Your bag is empty.') + '</p><a class="btn btn-ol" href="' + escapeHTML(LIF.shopUrl || '/collections/all') + '">' + escapeHTML(text.shopRange || 'Shop the range') + '</a></div>'; return; }
      items.innerHTML = cart.items.map(function (it) {
        var variant = (it.variant_title && it.variant_title.indexOf('Default') === -1) ? it.variant_title : '';
        var img = it.image ? '<img class="pi" src="' + it.image + '" alt="">' : '';
        return '<div class="it"><a class="ph" href="' + it.url + '" style="position:relative;display:block">' + img + '</a>' +
          '<div><b><a href="' + escapeHTML(it.url) + '">' + escapeHTML(it.product_title) + '</a></b><small>' + escapeHTML(variant) + '</small>' +
          '<div class="qty"><button data-dq="-1" data-key="' + it.key + '" aria-label="Decrease">−</button><span>' + it.quantity + '</span><button data-dq="1" data-key="' + it.key + '" aria-label="Increase">+</button></div><button type="button" class="drawer-remove" data-drawer-remove data-key="' + escapeHTML(it.key) + '">' + escapeHTML(text.remove || 'Remove') + '</button></div>' +
          '<div class="pr">' + money(it.final_line_price) + '</div></div>';
      }).join('');
    }
  }
  document.addEventListener('lif:cart:updated', function(event) {
    var cart = event.detail;
    renderDrawer(cart);
    var shipping = $('.summary .sum-ship');
    var drawerShipping = $('#ship');
    if (shipping && drawerShipping) shipping.innerHTML = FREE > 0 ? drawerShipping.innerHTML : escapeHTML(text.deliveryCalculated || 'Calculated at checkout');
    $all('[data-cart-delivery]').forEach(function(el) { el.textContent = FREE > 0 && cart.total_price >= FREE ? text.deliveryFree : text.deliveryCalculated; });
    $all('[data-cart-subtotal]').forEach(function(el) { el.textContent = money(cart.total_price); });
    $all('[data-cart-line][data-line-key]').forEach(function(el) {
      var item = cart.items.find(function(line) { return line.key === el.dataset.lineKey; });
      if (!item) {
        var candidate = cart.items[Number(el.dataset.cartLine) - 1];
        if (candidate && String(candidate.variant_id) === el.dataset.lineVariant) item = candidate;
      }
      var price = $('.ln-pr', el);
      if (!item) { el.remove(); return; }
      if (item) {
        var quantity = $('[data-qty-input]', el); if(quantity) quantity.value = item.quantity;
        if (price) price.textContent = money(item.final_line_price);
        el.dataset.lineKey = item.key;
        $all('[data-key]', el).forEach(function(control) { control.dataset.key = item.key; });
      }
    });
  });
  function refreshCart() {
    var feedback = $('[data-drawer-feedback]');
    if (feedback) feedback.textContent = text.loadingBag || 'Loading your bag…';
    if (drawer) drawer.setAttribute('aria-busy', 'true');
    var checkout = $('[data-drawer-checkout]'); if (checkout) checkout.disabled = true;
    return fetch(cartRoute('cart.js'), { headers: { 'Accept': 'application/json' } })
      .then(responseJSON).then(function(cart) {
        renderDrawer(cart);
        if (feedback) delete feedback.dataset.tone;
        if (feedback) feedback.textContent = '';
        return cart;
      }).catch(function(error) {
        if (feedback) feedback.textContent = text.bagError || 'We could not load your bag. Open View bag to review it or try again.';
        throw error;
      }).finally(function() { if (drawer) drawer.setAttribute('aria-busy', 'false'); });
  }
  var recommendationRevision = 0;
  function refreshRecommendations(data) {
    var slot = $('[data-cart-recommendations-slot]');
    if (!slot) return;
    var revision = ++recommendationRevision;
    function apply(html) {
      if (revision !== recommendationRevision) return;
      if (typeof html !== 'string') { slot.innerHTML = ''; return; }
      var fragment = document.createElement('div');
      fragment.innerHTML = html;
      var section = $('[data-lif-category-recs]', fragment);
      slot.replaceChildren();
      if (section && section.querySelector('.lif-cart-rec-item')) {
        $all('img', section).forEach(function(img) { img.loading = 'eager'; });
        slot.appendChild(section);
      }
    }
    var html = data.sections && data.sections['lif-cart-recommendations'];
    if (typeof html === 'string') { apply(html); return; }
    slot.innerHTML = '';
    fetch(cartRoute('cart') + '?sections=lif-cart-recommendations', {headers:{'Accept':'application/json'}})
      .then(responseJSON).then(function(sections) { apply(sections['lif-cart-recommendations']); })
      .catch(function() { if(revision === recommendationRevision) slot.innerHTML = ''; });
  }
  function addToCart(id, qty) {
    setCartPending(true);
    return fetch(cartRoute('cart/add.js'), {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty || 1, sections: ['lif-cart-recommendations'], sections_url: cartRoute('cart') })
    }).then(responseJSON).then(function (data) { refreshRecommendations(data); return refreshCart().catch(function() {}); }).then(function () { openBag(); })
      .finally(function() { setCartPending(false); });
  }
  function changeLine(key, qty) {
    setCartPending(true);
    return fetch(cartRoute('cart/change.js'), {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty, sections: ['lif-cart-recommendations'], sections_url: cartRoute('cart') })
    }).then(responseJSON).then(function(cart) { refreshRecommendations(cart); return cart; }).finally(function() { setCartPending(false); });
  }

  // quick add from cards
  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-cart-add]');
    if (add && add.dataset.variantId) { e.preventDefault(); if(cartPending)return; var addLabel=add.textContent; add.disabled=true; add.setAttribute('aria-busy','true'); add.textContent=text.adding || 'Adding…'; addToCart(add.dataset.variantId, 1).catch(reportError).finally(function(){add.disabled=false;add.textContent=addLabel;add.removeAttribute('aria-busy');}); return; }
    var remove = e.target.closest('[data-drawer-remove]');
    if(remove) {
      e.preventDefault(); if(cartPending)return;
      changeLine(remove.dataset.key, 0).then(function(cart) {
        document.dispatchEvent(new CustomEvent('lif:cart:updated', {detail:cart}));
        $('[data-close]', drawer).focus();
      }).catch(reportError); return;
    }
    var dq = e.target.closest('[data-dq]');
    if (dq) {
      e.preventDefault(); if(cartPending)return;
      var span = dq.parentNode.querySelector('span');
      var cur = parseInt(span ? span.textContent : '1', 10) || 1;
      var next = Math.max(0, cur + parseInt(dq.dataset.dq, 10));
      var key = dq.dataset.key, direction = dq.dataset.dq;
      changeLine(key, next).then(function(cart) {
        document.dispatchEvent(new CustomEvent('lif:cart:updated', {detail:cart}));
        var target = $all('[data-dq]', drawer).find(function(b) {return b.dataset.key === key && b.dataset.dq === direction;});
        (target || $('[data-close]', drawer)).focus();
        var feedback = $('[data-drawer-feedback]'); if(feedback) { delete feedback.dataset.tone; feedback.textContent = text.updated || 'Bag updated.'; }
      }).catch(reportError);
      return;
    }
  });

  // product add-to-cart form (AJAX)
  var pform = $('#product-form, [data-product-form]');
  if (pform) {
    var enabledId=pform.querySelector('[data-variant-id]');if(enabledId)enabledId.disabled=false;
    pform.addEventListener('submit', function (e) {
      e.preventDefault();
      var id = (pform.querySelector('[data-variant-id]') || {}).value;
      var qty = parseInt((pform.querySelector('[data-qty-input]') || {}).value || '1', 10);
      if (!id || cartPending) return;
      var submit = $('[data-cart-submit]', pform);
      if (submit && submit.disabled) return;
      var feedback = $('[data-cart-feedback]'); if (feedback) { feedback.textContent = ''; delete feedback.dataset.tone; }
      if (submit) { submit.disabled = true; submit.setAttribute('aria-busy', 'true'); submit.textContent = text.adding || 'Adding…'; }
      addToCart(id, qty).then(function() { if (feedback) { feedback.dataset.tone='success'; feedback.textContent = text.added || 'Added to your bag.'; } }).catch(reportError).finally(function() {
        if (submit) { submit.removeAttribute('aria-busy'); submit.disabled = false; }
        syncProductUI();
      });
    });
  }

  var gallery = $('[data-product-gallery]');
  var galleryTrack = gallery && $('[data-gallery-track]', gallery);
  var mediaEl = $('[data-media-json]');
  var galleryMedia = mediaEl ? JSON.parse(mediaEl.textContent || '[]') : [];
  var galleryOptionsEl = $('[data-gallery-options]');
  var galleryOptions = galleryOptionsEl ? JSON.parse(galleryOptionsEl.textContent || '[]') : [];
  var activeMediaIds = [];
  function updateGalleryControls() {
    if (!galleryTrack) return;
    var panes = $all('[data-media-pane]', gallery).filter(function(pane) { return !pane.hidden; });
    var controls = $('[data-gallery-controls]', gallery);
    if (!controls) return;
    controls.hidden = panes.length < 2;
    var index = panes.findIndex(function(pane) { return Math.abs(pane.offsetLeft - galleryTrack.scrollLeft) < galleryTrack.clientWidth / 2; });
    index = Math.max(0, index);
    var counter = $('[data-gallery-counter]', controls);
    if (counter) counter.textContent = (index + 1) + ' / ' + panes.length;
    $('[data-gallery-prev]', controls).disabled = index === 0;
    $('[data-gallery-next]', controls).disabled = index === panes.length - 1;
  }
  function colourKey(value) {
    return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }
  function galleryIds(variant, items, options) {
    var colourIndex = options.findIndex(function(option) { return /colou?r/i.test(option.name); });
    var colourOption = options[colourIndex];
    var colour = colourIndex < 0 ? '' : colourKey((variant.options || [])[colourIndex]);
    var multiColour = colourOption && colourOption.values.length > 1;
    var anchorId = variant.featured_media && String(variant.featured_media.id);
    var images = items.filter(function(item) {
      return item.type === 'image' && (!multiColour || item.colour === colour || (!item.colour && String(item.id) === anchorId));
    });
    var front = images.find(function(item) { return item.view === 'front'; });
    var back = images.find(function(item) { return item.view === 'back'; });
    var backFirst = $('[data-product-wrapper]') && $('[data-product-wrapper]').dataset.photoPreference === 'back';
    if (front && back) return backFirst ? [String(back.id), String(front.id)] : [String(front.id), String(back.id)];
    if (backFirst && back) return [String(back.id)];
    var anchor = items.find(function(item) { return String(item.id) === anchorId; });
    var fallback = anchor || images[0] || items[0];
    return fallback ? [String(fallback.id)] : [];
  }
  function displayMedia(ids) {
    if (!gallery || !galleryTrack || !ids.length) return;
    activeMediaIds = ids.map(String);
    galleryTrack.classList.toggle('is-paired', ids.length === 2);
    $all('[data-media-pane]', gallery).forEach(function(pane) {
      var index = activeMediaIds.indexOf(String(pane.dataset.mediaPane));
      pane.hidden = index < 0;
      pane.style.order = index < 0 ? '' : String(index);
      if (pane.hidden) {
        $all('video', pane).forEach(function(video) { video.pause(); });
        $all('iframe', pane).forEach(function(frame) { var src = frame.getAttribute('src'); if (src) frame.setAttribute('src', src); });
      }
    });
    $all('[data-thumb]', gallery).forEach(function(thumb) {
      var visible = activeMediaIds.indexOf(String(thumb.dataset.mediaId)) >= 0;
      thumb.classList.toggle('on', visible);
      thumb.setAttribute('aria-pressed', visible ? 'true' : 'false');
    });
    galleryTrack.scrollLeft = 0;
    updateGalleryControls();
  }
  function showMedia(id) {
    if (!id || !galleryTrack) return;
    id = String(id);
    if (activeMediaIds.indexOf(id) < 0) displayMedia([id]);
    var pane = $all('[data-media-pane]', gallery).find(function(item) { return String(item.dataset.mediaPane) === id; });
    if (pane && window.matchMedia('(max-width: 700px)').matches) galleryTrack.scrollTo({left: pane.offsetLeft, behavior: 'instant'});
  }
  if (galleryTrack) galleryTrack.addEventListener('keydown', function(event) {
    if (event.target !== galleryTrack || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
    event.preventDefault();
    galleryTrack.scrollBy({left: (event.key === 'ArrowRight' ? 1 : -1) * galleryTrack.clientWidth, behavior: 'instant'});
  });
  if (galleryTrack) {
    galleryTrack.addEventListener('scroll', updateGalleryControls, {passive: true});
    window.addEventListener('resize', updateGalleryControls, {passive: true});
    $all('[data-gallery-prev], [data-gallery-next]', gallery).forEach(function(button) {
      button.addEventListener('click', function() {
        var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        galleryTrack.scrollBy({left: (button.hasAttribute('data-gallery-next') ? 1 : -1) * (galleryTrack.clientWidth + 12), behavior: reduced ? 'instant' : 'smooth'});
      });
    });
    updateGalleryControls();
  }
  /* ---------- Product variants ---------- */
  var vjsonEl = $('[data-variant-json]');
  if (vjsonEl) {
    var variants = JSON.parse(vjsonEl.textContent || '[]');
    var selected = [];
    $all('[data-option-value]').forEach(function (b) { if (b.classList.contains('on')) selected[parseInt(b.dataset.optionValue, 10) - 1] = b.dataset.value; });

    function currentVariant() {
      return variants.find(function (v) {
        return selected.every(function (val, i) { return !val || v.options[i] === val; });
      });
    }
    function updateOptionAvailability() {
      $all('[data-option-value]', pform || document).forEach(function(button) {
        var index = Number(button.dataset.optionValue) - 1;
        var colour = !!button.closest('[data-colour-options]');
        var available = variants.some(function(variant) {
          if (!variant.available || variant.options[index] !== button.dataset.value) return false;
          return colour || selected.every(function(value, i) { return i === index || !value || variant.options[i] === value; });
        });
        button.classList.toggle('is-sold-out', !available);
        button.disabled = !colour && !available;
        if (!colour) button.setAttribute('aria-disabled', available ? 'false' : 'true');
        button.setAttribute('aria-label', button.dataset.value + (available ? '' : ' — ' + (text.soldOut || 'Sold out')));
        button.title = button.dataset.value + (available ? '' : ' — ' + (text.soldOut || 'Sold out'));
      });
    }
    function updateVariant() {
      updateOptionAvailability();
      var v = currentVariant();
      var idInput = $('[data-variant-id]');
      var btn = $('[data-cart-submit]', pform || document);
      var status = $('[data-availability]');
      if (!v) {
        if (idInput) idInput.value = '';
        if (btn) { btn.disabled = true; btn.textContent = text.unavailable || 'This combination is unavailable.'; }
        if (status) { status.textContent = (text.unavailable || 'This combination is unavailable.') + ' ' + (text.chooseAvailable || 'Choose an available size or colour.'); status.classList.add('is-unavailable'); }
        var invalidUrl = new URL(window.location.href); invalidUrl.searchParams.delete('variant'); window.history.replaceState({}, '', invalidUrl);
        var compare = $('[data-compare-price]'); if(compare) compare.hidden = true;
        displayMedia(galleryIds({options:selected}, galleryMedia, galleryOptions));
        return;
      }
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url);
      if (idInput) idInput.value = v.id;
      var price = $('[data-price]'); if (price) price.textContent = money(v.price);
      var comparePrice = $('[data-compare-price]');
      if (comparePrice) { comparePrice.hidden = !(v.compare_at_price > v.price); if (!comparePrice.hidden) comparePrice.textContent = money(v.compare_at_price); }
      if (btn) { btn.textContent = cartPending ? (text.adding || 'Adding…') : v.available ? (btn.dataset.addLabel || 'Add to bag') : (btn.dataset.soldLabel || 'Sold out'); btn.disabled = cartPending || !v.available; }
      if (status) { status.textContent = v.available ? (text.available || 'Available to order') : (text.soldOut || 'Sold out') + ' — ' + (text.chooseAvailable || 'Choose an available size or colour.'); status.classList.toggle('is-unavailable', !v.available); }
      var ids = galleryIds(v, galleryMedia, galleryOptions);
      if (ids.join(',') !== activeMediaIds.join(',')) displayMedia(ids);
    }
    syncProductUI = updateVariant;
    document.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-option-value]');
      if (!opt || opt.disabled) return;
      e.preventDefault();
      var pos = parseInt(opt.dataset.optionValue, 10);
      selected[pos - 1] = opt.dataset.value;
      var wrap = opt.closest('[data-option-wrap]');
      if (wrap) $all('[data-option-value]', wrap).forEach(function (x) { x.classList.toggle('on', x === opt); x.setAttribute('aria-pressed',x===opt?'true':'false'); });
      var lbl = $('[data-option-label="' + pos + '"]'); if (lbl) lbl.textContent = opt.dataset.value;
      var feedback=$('[data-cart-feedback]'); if(feedback)feedback.textContent='';
      updateVariant();
    });
    updateVariant();
  }

  /* ---------- Product thumbnails ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-thumb]');
    if (!t) return;
    e.preventDefault();
    showMedia(t.dataset.mediaId);
  });

  /* ---------- PDP quantity stepper ---------- */
  (function () {
    var disp = $('[data-qty-display]'), input = $('[data-qty-input]');
    if (!disp || !input) return;
    var qv = 1;
    $all('[data-step]').forEach(function (b) {
      b.addEventListener('click', function () { qv = Math.max(1, qv + parseInt(b.dataset.step, 10)); disp.textContent = qv; input.value = qv; var minus=$('[data-step="-1"]'); if(minus)minus.disabled=qv===1; });
    });
  })();

  var cartPageForm = $('[data-cart-page-form]'); if(cartPageForm) cartPageForm.classList.add('auto-update');
  function updateCartPage(cart) {
    if(!cart.item_count) { window.location.reload(); return; }
    document.dispatchEvent(new CustomEvent('lif:cart:updated', {detail:cart}));
    var feedback = $('[data-cart-feedback]'); if(feedback) { delete feedback.dataset.tone; feedback.textContent = text.updated || 'Bag updated.'; }
  }
  document.addEventListener('change', function(event) {
    var input = event.target.closest('[data-cart-page-form] [data-qty-input]');
    if(!input || cartPending)return;
    if(input.value === '') { input.value = String((latestCart.items || []).find(function(item) {return item.key === input.dataset.key;})?.quantity || 1); return; }
    if(!input.checkValidity()) { input.reportValidity(); return; }
    changeLine(input.dataset.key, Number(input.value)).then(updateCartPage).catch(reportError);
  });
  /* ---------- Cart page qty / remove ---------- */
  document.addEventListener('click', function (e) {
    var qc = e.target.closest('[data-qchange]');
    if (qc) {
      e.preventDefault(); if(cartPending)return;
      var inp = document.querySelector('[data-qty-input][data-key="' + qc.dataset.key + '"]');
      var val = Math.max(0, (parseInt(inp.value, 10) || 0) + parseInt(qc.dataset.qchange, 10));
      changeLine(qc.dataset.key, val).then(updateCartPage).catch(reportError);
      return;
    }
    var rm = e.target.closest('[data-remove]');
    if (rm && rm.dataset.key) {
      e.preventDefault(); if(cartPending)return;
      changeLine(rm.dataset.key, 0).then(function(cart) { updateCartPage(cart); var heading = $('.cart-head'); if(heading) { heading.tabIndex=-1; heading.focus(); } }).catch(reportError);
      return;
    }
  });

  /* ---------- Collection / featured filter tabs ---------- */
  var tabs = $('#tabs');
  if (tabs) {
    tabs.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      $all('button', tabs).forEach(function (x) { x.classList.toggle('on', x === b); });
      var f = b.dataset.f;
      $all('#grid .card').forEach(function (c) { c.classList.toggle('hidden', f !== 'all' && c.dataset.f !== f); });
    });
  }

  window.LIFSort=true;
  var contactResult = $('.contact-success, .contact-errors');
  if (contactResult) { contactResult.setAttribute('tabindex', '-1'); contactResult.focus(); }
  var sortForm=$('[data-sort-form]'); if(sortForm)sortForm.addEventListener('change',function(){var url=new URL(window.location.href);url.searchParams.set('sort_by',sortForm.querySelector('select').value);url.searchParams.delete('page');window.location.assign(url.toString());});
  /* ---------- Header state ---------- */
  var H = $('#hdr');
  if (H) {
    var hasHero = !!$('.hero');
    function hs() { H.classList.toggle('solid', !hasHero || window.scrollY > 60); }
    window.addEventListener('scroll', hs, { passive: true }); hs();
  }

  /* ---------- Reveal ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    $all('.rv').forEach(function (el) { io.observe(el); });
  } else {
    $all('.rv').forEach(function (el) { el.classList.add('in'); });
  }

  // keep bag count fresh on load
  if ($('#bagCt')) refreshCart().catch(function() {});
})();
